import AlertPanel from 'ext-ui/components/AlertPanel/AlertPanel'
import AlertCircleIcon from 'ext-ui/svg/icon/AlertCircleIcon'
import React, { ReactElement } from 'react'
import { Link } from 'react-router-dom'
import style from 'src/feature/PhysicalCardHomepageError/PhysicalCardHomepageError.style'
import { useTranslate } from 'src/localization/Trns'

type PhysicalCardHomepageErrorProps = {
  className?: string
  linkTo: string
}

function PhysicalCardHomepageError(
  props: PhysicalCardHomepageErrorProps,
): ReactElement {
  const { className = '', linkTo } = props
  const translate = useTranslate()

  return (
    <AlertPanel variant="severe-wcag" className={className}>
      <div className="PhysicalCardHomepageError" css={style}>
        <div className="icon-column">
          <AlertCircleIcon />
        </div>
        <div className="content-column">
          <p className="title">{translate('Error connecting your card')}</p>
          <p>
            {translate('Please try to ')}
            <Link
              className="link"
              to={linkTo}
              aria-label={translate('connect your card again')}
            >
              {translate('connect')}
            </Link>
            {translate(' your card again')}
          </p>
        </div>
      </div>
    </AlertPanel>
  )
}

export default PhysicalCardHomepageError
